export default __webpack_public_path__ + "static/media/meetpharma-homepage-picture2.3b47b98e.jpg";